import { capitalize } from '@mui/material'
import { Tag } from '@carto/meridian-ds/components'

function TypeTag({ type }: { type: string }) {
  const label = type.toLowerCase()
  return <Tag label={capitalize(label)} variant="outlined" color="default" type="code" />
}

export default TypeTag
